import React,{useMemo,useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import Modal from 'react-modal';
import * as uuid from "uuid";
import useSaveNewPeriod from "../hooks/useSaveNewPeriod"
import {Header2,List,ListItem,Span,AddButton} from "../styled_components/exporter"
import { holidays } from "../utility/constants";
import { germanDate } from "../utility/momentPoly";
import moment from 'moment'
import Biscuit from '../../../../utils/Biscuit';
const customStyles = {
  content : {
    top                   : '50%',
    left                  : '45%',
    right                 : '40%',
    bottom                : 'auto',
    marginRight           : '-20%',
    transform             : 'translate(-50%, -50%)',
    overflow              : "auto",
  }
};
// const uuid = _.uniqueId;
const HolidayModal = ({ isOpen, setIsOpen,location }) => {
	const [readyToDispatch,setReadyToDispatch] = useState(false)
	const dispatch = useDispatch()
	const {changes,periods} = useSelector(data=>data.checkInTimes)
  const store = useSelector(data=>data.checkInTimes)
	const filteredHolidays = holidays && holidays.filter(holiday=>periods && periods.map(x=>moment(x.valid_from).format("YYYY-MM-DD")).indexOf(moment(Object.values(holiday)[0]).format("YYYY-MM-DD")) < 0 && moment(Object.values(holiday)[0]).format("YYYY-MM-DD") > moment(new Date()).format("YYYY-MM-DD"))
	const {holidayHandler} = useSaveNewPeriod()
	const addAndSave = (e,date,place)=>{
		let hours = periods.filter(period=>moment(period.valid_from).format("YYYY-MM-DD") <  moment(date).format("YYYY-MM-DD")) || []
		if(hours.length) hours = hours.slice(-1)[0].check_in_hours.map(hour=>{return{...hour,check_in_period_id: "",id: ""}})
			let i = 0
			let a = holidays.map(h=>moment(Object.values(h)[0]).format("YYYY-MM-DD"))
			while(a.indexOf(moment(date).add(i,"days").format("YYYY-MM-DD")) > -1){
					dispatch({
			      	type: "ADD_PERIOD",
			      	period: {
			        location_id: place,
			        check_in_hours: [],
			        valid_from: moment(date).add(i,"days").format("YYYY-MM-DD HH:mm:ss"),
			        type: "holiday",
			        id: "fakeID-" + Math.random()
			      }
			    });
			i++
			}
		dispatch({
      type: "ADD_PERIOD",
      period: {
        location_id: place,
        check_in_hours: hours,
        valid_from: moment(date).add(i,"days").format("YYYY-MM-DD HH:mm:ss"),
        type: "period",
        id: "fakeID-" + Math.random()
      }
    });
	
  		setReadyToDispatch(true)
		setIsOpen(false)
	}
	useMemo(() => {
		if(readyToDispatch) {
			holidayHandler()
			setReadyToDispatch(false)
		}
	}, [readyToDispatch])
	useMemo(() => {
		document.addEventListener("keydown",e=>{
			if(e.keyCode === 27){
				setIsOpen(false)
			}
		})
		return ()=>document.removeEventListener("keydown",()=>console.log("removed"))
		// eslint-disable-next-line
	},[])
        return ( <>
            <Modal isOpen={isOpen} ariaHideApp={false} style={customStyles} >
      <button onClick={()=>setIsOpen(false)} className={"button beautify beautify-" + Biscuit.get('user.client_id')} style={{position: "absolute",right: "21px",bottom: "96%",margin: "0 0 0 0",padding: "5px"}}>X</button>
      <List style={{paddingTop: "2rem",height: "80vh",overflowY: "auto"}}>  
       {filteredHolidays && filteredHolidays.map(x=><ListItem key={"uuid" + Math.random()} style={{margin: "10px 0",display: "flex",justifyContent: "space-between",width: "100%"}}><Span style={{fontSize: "1rem"}}>{Object.keys(x)[0]} - {germanDate(Object.values(x)[0])}</Span> <button onClick={(e)=>addAndSave(e,Object.values(x)[0],location)} className={"button beautify beautify-" + Biscuit.get('user.client_id')} style={{margin: "0 0 0 0"}}>Add Holiday Period</button></ListItem>)}
      </List>
      </Modal> </>)
        }
export default HolidayModal

   